import { createAsyncThunk } from "@reduxjs/toolkit";
import { talkToServer } from "@helpers/servercomms";
import * as isEqual from "react-fast-compare";

export const deepEquals = isEqual;

// Can't use structuredClone with Redux proxies
export const deepClone = (obj) => {
  if (!obj) return obj;
  return JSON.parse(JSON.stringify(obj));
};

const _getFromServerTopic =
  (router) =>
  (topic, action, contextOptionsFn, payloadFn, clientCacheTtlSeconds) =>
    createAsyncThunk(`${topic}/${action}`, async (arg, thunkAPI) => {
      const payload = payloadFn ? await payloadFn(arg, thunkAPI) : undefined;
      // contextOptionsFn receives both the original argument and the resolved payload,
      // this allows the caller to decide which is more convenient to use to create options
      const options = contextOptionsFn
        ? await contextOptionsFn({ arg, payload, thunkAPI })
        : undefined;

      const context = {
        topic,
        action,
        options,
      };

      if (clientCacheTtlSeconds) {
        context.useCache = true;
        context.expiresIn = clientCacheTtlSeconds;
      }

      const request = {
        context,
        payload,
      };
      const serverResponse = await talkToServer(request, router);
      if (serverResponse?.rc === "ERROR") {
        return thunkAPI.rejectWithValue(serverResponse.context);
      }

      return {
        response: serverResponse.payload.result ?? serverResponse.payload,
      };
    });

export const getFromServerTopic = ({
  topic,
  action,
  contextOptionsFn,
  payloadFn,
  clientCacheTtlSeconds,
}) =>
  _getFromServerTopic("data")(
    topic,
    action,
    contextOptionsFn,
    payloadFn,
    clientCacheTtlSeconds,
  );

export const getFromServerPublicTopic = ({
  topic,
  action,
  contextOptionsFn,
  payloadFn,
  clientCacheTtlSeconds,
}) =>
  _getFromServerTopic("public")(
    topic,
    action,
    contextOptionsFn,
    payloadFn,
    clientCacheTtlSeconds,
  );

const _getFromServerTopic2 =
  (router) => (topic, name, payloadFn, thunkOptions) =>
    createAsyncThunk(
      `${topic}/${name}`,
      async (arg, thunkAPI) => {
        const payload = payloadFn ? await payloadFn(arg, thunkAPI) : undefined;
        const request = {
          context: {
            topic,
            action: name,
          },
          payload,
        };
        const serverResponse = await talkToServer(request, router);
        //console.log("_getFromServerTopic2", JSON.stringify(request));
        //console.log("_getFromServerTopic2", JSON.stringify(serverResponse));
        return { ...serverResponse };
      },
      thunkOptions,
    );

export const getFromServerTopic2 = (topic, name, payloadFn, thunkOptions) =>
  _getFromServerTopic2("data")(topic, name, payloadFn, thunkOptions);

// const _getFromServerTopicWithOptions = (router) => (topic, name, options, payloadFn) =>
//   createAsyncThunk(`${topic}/${name}`, async (arg, thunkAPI) => {
//     console.log("calling w options", options);
//     const payload = payloadFn ? await payloadFn(arg, thunkAPI) : undefined;
//     const request = {
//       context: {
//         topic,
//         action: name,
//         options,
//       },
//       payload,
//     };
//     const serverResponse = await talkToServer(request, router);
//     //console.log("_getFromServerTopic2", JSON.stringify(serverResponse));
//     return { ...serverResponse };
//   });
